import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { AccountCircle } from "@mui/icons-material";

import { resetPassword } from "../../features/Auth/authSlice";
import { toggleLogin } from "../../features/modals/modalSlice";

const ResetPassword = () => {
  //   const [email, setEmail] = useState();
  const [logs, setLogs] = useState({
    email: "",
    password: "",
    password_confirmation: "",
    token: "",
  });

  const { errorMsg, success, message } = useSelector((state) => state.auth);

  const [searchParams] = useSearchParams();
  const assesToken = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    for (const entry of searchParams.entries()) {
      const [emailToken, emailTokenValue] = entry;
      const { token } = assesToken;
      console.log(token);

      setLogs({ ...logs, token, email: emailTokenValue });
    }
  }, []);

  const handleChange = (e) => {
    setLogs({
      ...logs,
      [e.target.name]: e.target.value,
    });
  };

  const handleResetPasswordSubmit = (e) => {
    e.preventDefault();
    dispatch(resetPassword(logs));
    if (success === true) {
      navigate("/");
      dispatch(toggleLogin());
    }
  };

  return (
    <>
      {/* {JSON.stringify(logs)} */}
      <Container maxWidth="sm">
        <Box
          sx={{
            height: "80vh",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <Paper p={2} elevation={2}>
            <Box
              sx={{ p: 2 }}
              component="form"
              id="resetPassword"
              onSubmit={handleResetPasswordSubmit}
            >
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                {message ? (
                  <Typography color="error" variant="h5">
                    {message}
                  </Typography>
                ) : (
                  <Typography variant="h5">Rest Password</Typography>
                )}
              </Box>
              <Box py={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                      <AccountCircle
                        sx={{ color: "action.active", mr: 1, my: 0.5 }}
                      />
                      <TextField
                        id="input-with-sx"
                        label="Email"
                        variant="standard"
                        fullWidth
                        onChange={handleChange}
                        value={logs.email}
                        type="email"
                        name="email"
                        helperText={errorMsg?.email}
                        disabled
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                      <AccountCircle
                        sx={{ color: "action.active", mr: 1, my: 0.5 }}
                      />
                      <TextField
                        id="input-with-sx"
                        label="Password "
                        variant="standard"
                        fullWidth
                        type="password"
                        onChange={handleChange}
                        value={logs.password}
                        name="password"
                        helperText={errorMsg?.password}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                      <AccountCircle
                        sx={{ color: "action.active", mr: 1, my: 0.5 }}
                      />
                      <TextField
                        id="input-with-sx"
                        label="confirm password "
                        variant="standard"
                        fullWidth
                        type="password"
                        onChange={handleChange}
                        value={logs.password_confirmation}
                        name="password_confirmation"
                        // helperText={{}}
                      />
                    </Box>
                  </Grid>
                </Grid>
                <TextField
                  id="input-with-sx"
                  variant="standard"
                  fullWidth
                  type="hidden"
                  value={logs.token}
                  name="token"
                  onChange={handleChange}
                  hidden
                  disabled
                />
              </Box>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Button variant="outlined" size="large" type="submit">
                  update
                </Button>
              </Box>
            </Box>
          </Paper>
        </Box>
      </Container>
    </>
  );
};

export default ResetPassword;
